import React from 'react';
import { AiOutlineLink } from 'react-icons/ai';

function CarouselCookiesItem(props) {
  return (
    <div className='carousel_item'>
      <div className='carousel_item_container d-flex-row align-items-center justify-content-between'>
        <img src={props.image} alt='carousel_img' />
        <div className='text'>
          <h2 className='text-title'>{props.title}</h2>
          <p className='text-gray'>{props.subtitle}</p>
        </div>
        <a target='_blank' rel='noopener noreferrer' href={props.link}>
          <button className='d-flex-row align-items-center justify-content-center'>
            <AiOutlineLink /> Learn more
          </button>
        </a>
      </div>
    </div>
  );
}

export default CarouselCookiesItem;
